import axios from "axios";
import config from "../config";
import { deepSanitizeImageUrls } from "../utils/sanitizeImageUrl";
import { handlePossiblyExpiredAuth } from "../../utils/sessionExpiry";

export const Api = axios.create({
  baseURL: config.baseUrl,
  timeout: 100000,
});

// Sanitize doubled image URLs on every axios response from the dealers API
Api.interceptors.response.use((response) => {
  if (response && response.data != null) {
    response.data = deepSanitizeImageUrls(response.data);
  }
  return response;
});

export const API_ENDPOINT = (label) => {
  return `${config.baseUrl}${label}`;
};
// post
export function* fetchData(e) {
  const { label, data, method, header, contentType } = e.payload;
  const headers = new Headers(header);
  if (header) {
    Object.keys(header).forEach((key) => {
      headers.append(key, header[key]);
    });
  }
  const methodUpper = String(method || "GET").toUpperCase();
  const isBodyless =
    methodUpper === "GET" ||
    methodUpper === "HEAD" ||
    methodUpper === "DELETE";

  let parameters;
  if (contentType) {
    parameters = {
      method: methodUpper,
      body: data,
      headers,
    };
  } else if (isBodyless) {
    parameters = {
      method: methodUpper,
      headers,
    };
  } else {
    headers.append("Content-Type", "application/json");
    parameters = {
      method: methodUpper,
      headers,
      body: JSON.stringify(data ?? {}),
    };
  }
  return yield fetch(API_ENDPOINT(label), parameters)
    .then(async (response) => {
      const contentTypeHeader = response.headers.get("content-type") || "";
      if (!contentTypeHeader.includes("application/json")) {
        // A non-JSON body here is usually a server error page, not a client bug.
        return {
          data: {},
          message: {
            type: "error",
            show: true,
            autoHide: true,
            heading: "Error",
            description:
              response.status >= 500
                ? `The server could not return these details (error ${response.status}). Please try again later.`
                : "Unable to load vehicle details.",
          },
        };
      }
      const json = await response.json();
      // Only redirect when the API body says the token is not authorized.
      handlePossiblyExpiredAuth({
        status: response.status,
        data: json,
        url: label,
      });
      return json;
    })
    .then((json) => {
      return deepSanitizeImageUrls(json);
    });
}
